/**
 * MagicLinkOnboarding Page - Now uses UnifiedOTP component
 * Handles magic link onboarding for pre-configured doctors
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import UnifiedOTP from '../../components/UnifiedOTP';

const MagicLinkOnboarding = () => {
    const navigate = useNavigate();

    const handleSuccess = (result) => {
        // Redirect to doctor dashboard
        navigate('/doctor-dashboard');
    };

    const handleError = (error) => {
        console.error('Magic link onboarding error:', error);
        // Error handling is done in UnifiedOTP component
    };

    return ( <
        UnifiedOTP mode = "magic-link"
        onSuccess = { handleSuccess }
        onError = { handleError }
        showSteps = { true }
        title = "Welcome to MindWell! 🚀"
        subtitle = "Your account has been pre-configured. Please set your password to get started." /
        >
    );
};

export default MagicLinkOnboarding;